<footer class="cr-footer">
  <div class="cr-footer__inner">
    <div class="cr-footer__grid">
      <!-- Brand -->
      <div class="cr-footer__brand">
        <span class="cr-footer__logo">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M4 4 L4 20 L20 20" stroke="currentColor" stroke-width="2.6" stroke-linecap="square" fill="none"/>
            <circle cx="4" cy="4" r="1.8" fill="currentColor"/>
            <path d="M8 20 L8 17 M12 20 L12 16 M16 20 L16 17" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" opacity="0.55"/>
          </svg>
          <span>craftly</span>
        </span>
        <p class="cr-footer__tagline">Der faire Marktplatz für Handwerk in Deutschland.</p>
      </div>

      <!-- Column: Für Kunden -->
      <div class="cr-footer__col">
        <h4 class="cr-footer__col-title">Für Kunden</h4>
        <ul class="cr-footer__list">
          <li><a routerLink="/suche" class="cr-footer__link">Suchen</a></li>
          <li><a routerLink="/notfall" class="cr-footer__link">Notfall 24/7</a></li>
          <li><a routerLink="/so-funktionierts" class="cr-footer__link">So funktioniert's</a></li>
          <li><a routerLink="/hilfe/kunden" class="cr-footer__link">Hilfe</a></li>
        </ul>
      </div>

      <!-- Column: Für Handwerker -->
      <div class="cr-footer__col">
        <h4 class="cr-footer__col-title">Für Handwerker</h4>
        <ul class="cr-footer__list">
          <li><a routerLink="/registrieren/handwerker" class="cr-footer__link">Handwerker werden</a></li>
          <li><a routerLink="/handwerker/preismodell" class="cr-footer__link">Preismodell</a></li>
          <li><a routerLink="/hilfe/handwerker" class="cr-footer__link">Hilfe</a></li>
        </ul>
      </div>

      <!-- Column: Craftly -->
      <div class="cr-footer__col">
        <h4 class="cr-footer__col-title">Craftly</h4>
        <ul class="cr-footer__list">
          <li><a routerLink="/ueber-uns" class="cr-footer__link">Über uns</a></li>
          <li><a routerLink="/kontakt" class="cr-footer__link">Kontakt</a></li>
        </ul>
      </div>

      <!-- Column: Rechtliches -->
      <div class="cr-footer__col">
        <h4 class="cr-footer__col-title">Rechtliches</h4>
        <ul class="cr-footer__list">
          <li><a routerLink="/agb" class="cr-footer__link">AGB</a></li>
          <li><a routerLink="/widerruf" class="cr-footer__link">Widerruf</a></li>
          <li><a routerLink="/bewertungs-richtlinien" class="cr-footer__link">Bewertungs-Richtlinien</a></li>
          <li><a routerLink="/datenschutz" class="cr-footer__link">Datenschutz</a></li>
          <li><a routerLink="/impressum" class="cr-footer__link">Impressum</a></li>
          <li><a routerLink="/cookies" class="cr-footer__link">Cookies</a></li>
          <li>
            <button type="button" class="cr-footer__link cr-footer__link--button" (click)="onCookieSettings()">
              Cookie-Einstellungen
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div class="cr-footer__cookie-notice">
      Technisch notwendige Cookies (Login, Sicherheit) sind immer aktiv. Statistik-Cookies
      (Google Analytics) setzen wir nur mit deiner Einwilligung — jederzeit über
      <button type="button" class="cr-footer__link cr-footer__link--button" (click)="onCookieSettings()">Cookie-Einstellungen</button>
      änderbar. <a routerLink="/cookies" class="cr-footer__link">Mehr dazu</a>.
    </div>

    <div class="cr-footer__bottom">
      <span>© {{ year }} Kulatrix UG (haftungsbeschränkt)</span>
      <span>Mit Handwerk gebaut.</span>
    </div>
  </div>
</footer>
